Bingo.DeveloperProjectSoldBy = {};

Bingo.DeveloperProjectSoldBy.init = function (toggleMySelf, toggleAgencies) {
    $('#type_myself_user').toggle(toggleMySelf);
    $('#type_agencies_user').toggle(toggleAgencies);
};

Bingo.DeveloperProjectSoldBy.toggleMyself = function (el) {
    $('#type_myself_user').toggle($(el).is(':checked'));
    if ($(el).is(':checked') === false) {
        $('input[name="user"]').attr('checked', false);
    }
};

Bingo.DeveloperProjectSoldBy.toggleAgencies = function (el) {
    $('#type_agencies_user').toggle($(el).is(':checked'));
    if ($(el).is(':checked') === false) {
        $('select.multiselect')[0].selectize.clear();
    }
};
